import { extendTheme } from '@chakra-ui/react';
import {
  ASSET_PATTERN_COLOR,
  BG_ALTERNATIVE,
  BG_PRIMARY,
  BG_SECONDARY,
  BG_TERTIARY,
  TEXT_ALTERNATIVE,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
  TEXT_TERTIARY,
} from '@/constants/colors';
import { FONT_FAMILY } from '@/constants/default-props';

const theme = {
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false,
    disableTransitionOnChange: false,
  },
  fonts: {
    heading: FONT_FAMILY.heading,
    subHeading: FONT_FAMILY.subHeading,
    body: FONT_FAMILY.body,
    name: FONT_FAMILY.name,
    accent: FONT_FAMILY.accent,
    jost: FONT_FAMILY.accent,
    delafield: FONT_FAMILY.subHeading,
  },
  fontSizes: {
    heading: '30px',
    subHeading: '58px',
    body: '16px',
    name: '48px',
  },
  fontWeights: {
    heading: 400,
    subHeading: 400,
    body: 400,
    name: 400,
  },
  colors: {
    bgPrimary: BG_PRIMARY,
    bgSecondary: BG_SECONDARY,
    bgTertiary: BG_TERTIARY,
    bgAlternative: BG_ALTERNATIVE,
    mainColorText: TEXT_PRIMARY,
    secondaryColorText: TEXT_SECONDARY,
    tertiaryColorText: TEXT_TERTIARY,
    alternativeColorText: TEXT_ALTERNATIVE,
    assetPatternColor: ASSET_PATTERN_COLOR,
    transparent: 'transparent',
  },
  styles: {
    global: {
      ':root': {
        '--fontItalic-heading': '',
        '--fontItalic-subHeading': '',
        '--fontItalic-body': '',
        '--fontItalic-name': '',
      },
      'html, body': {
        backgroundColor: BG_PRIMARY,
        color: TEXT_PRIMARY,
      },
    },
  },
};

export default extendTheme(theme);
